import React, { useState, useEffect } from 'react';
import { InviteChoicePopup } from '@/components/InviteChoicePopup';

interface InviteChoiceHandlerProps {
  children: React.ReactNode;
}

export const InviteChoiceHandler: React.FC<InviteChoiceHandlerProps> = ({ children }) => {
  const [showInviteChoice, setShowInviteChoice] = useState(false);
  const [inviteData, setInviteData] = useState<any>(null);

  useEffect(() => {
    // Check for pending invitation context after authentication
    const checkPendingInvitation = () => {
      const pendingInviteContext = localStorage.getItem('pendingInviteContext');
      const inviteChoice = localStorage.getItem('inviteChoice');
      
      // Only show if we have invitation context but no choice has been made yet
      if (pendingInviteContext && !inviteChoice) {
        try {
          const inviteData = JSON.parse(pendingInviteContext);
          console.log('🎯 PHASE 1: Found pending invitation, showing choice popup:', inviteData);
          setInviteData(inviteData);
          setShowInviteChoice(true);
        } catch (error) {
          console.error('❌ PHASE 1: Error parsing invitation context:', error);
          // Clean up invalid data
          localStorage.removeItem('pendingInviteContext');
        }
      }
    };

    // Small delay to ensure authentication is complete
    const timer = setTimeout(checkPendingInvitation, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleConnectChoice = () => {
    console.log('🎯 PHASE 1: User chose to connect with inviter');
    localStorage.setItem('inviteChoice', 'connect');
    setShowInviteChoice(false);
  };

  const handleJustMeChoice = () => {
    console.log('🎯 PHASE 1: User chose "Just me" - skipping connection');
    localStorage.setItem('inviteChoice', 'skip');
    setShowInviteChoice(false);
  };

  return (
    <>
      {children}
      
      {showInviteChoice && inviteData && (
        <InviteChoicePopup
          inviterName={inviteData.inviterName}
          inviterAvatar={inviteData.inviterAvatar}
          clickedAt={inviteData.clickedAt}
          onConnectChoice={handleConnectChoice}
          onJustMeChoice={handleJustMeChoice}
        />
      )}
    </>
  );
};
